import { ThemeConfig } from "./types";

// Default theme with all the original colors from tailwind.config.js
export const defaultTheme: ThemeConfig = {
  name: "default",
  colors: {
    // Primary colors
    primary: "#2B75D0",
    primary50: "#5F98DF",
    primary100: "#2060AE",
    primary_light: "#5DB9CE",
    primary_lighter: "#CAEFF5",
    secondary: "#61BBCF",

    // Common colors
    transparent: "rgba(0,0,0,0)",
    white: "#ffffff",
    black: "#424242",
    dark: "#000000",

    // Background colors
    bg_gray: "#F6F6F6",

    // Gray variations
    gray: "#CDCDCD",
    gray_selected: "#F4F4F4",
    border_gray: "#EDEDED",
    light_gray: "#E6E6E6",
    text_gray: "#424242",

    // Button specific colors
    buttonText: "#ffffff",
    buttonHover: "#5F98DF", // Same as primary50
    buttonActive: "#2060AE", // Same as primary100

    // Filled button colors
    buttonBg: "#2B75D0", // Same as primary
    buttonBgHover: "#5F98DF", // Same as primary50
    buttonBgActive: "#2060AE", // Same as primary100
    buttonBgDisabled: "#CDCDCD", // Same as gray

    // Outlined button colors
    buttonOutlinedBorder: "#2B75D0", // Same as primary
    buttonOutlinedBorderHover: "#5F98DF", // Same as primary50
    buttonOutlinedBorderActive: "#2060AE", // Same as primary100
    buttonBorderDisabled: "#CDCDCD", // Same as gray
    buttonOutlinedText: "#2B75D0", // Same as primary
    buttonOutlinedTextHover: "#5F98DF", // Same as primary50
    buttonOutlinedTextActive: "#2060AE", // Same as primary100
    buttonOutlinedTextDisabled: "#CDCDCD", // Same as gray

    // Tooltip colors
    tooltipBackground: "#ffffff",
    tooltipText: "#424242",

    // Modal styles
    modalBackdrop: "rgb(205 205 205 / 0.8)",
    modalBackdropFilter: "blur(4px)",
    modalMarginLeft: "auto",
    modalMarginRight: "auto",
    modalMarginTop: "auto",
    modalMarginBottom: "auto",

    // Status colors
    success: "#4FB23E",
    error: "#EF1111",
    warning: "#F9A825",
    info: "#1565C0",
    danger: "#FF7A00",
    yellow: "#F6D215",
  },
  typography: {
    fontFamily: "Montserrat",
    fontSize: {
      little: "7px",
      small: "8px",
      base: "10px",
      base_xl: "12px",
      base_l: "14px",
      base_x: "16px",
      large: "18px",
    },
  },
  borderRadius: {
    small: "3px",
    middle: "5px",
    big: "50px",
  },
  shadows: {
    popup: "0px 0px 6px rgba(0, 0, 0, 0.15)",
  },
  interfaceElements: ["header", "contacts", "footer"],
};
